<script>
import CountdownTimer from './ui/CountdownTimer';

export default {
  name: 'CountdownTimerWithLabel',
  props: {
    ...CountdownTimer.props,
    station: { required: true },
  },
  computed: {
    statusLabel () {
      let label;
      switch (this.status) {
      case 'offline':
        label = this.$t('Attempting to reconnect');
        break;
      case 'active':
        label = this.remainingTime > 0 ? this.$t('Time remaining') : this.$t('Time’s up!');
        break;
      case 'paused':
        label = this.$t('Paused');
        break;
      case 'disabled':
        label = this.$t('Waiting to start');
        break;
      case 'expired':
        label = this.$t('Time’s up');
        break;
      case 'infinite':
        label = this.$t('Infinite');
        break;
      default:
      }
      return label;
    },
  },
  components: {
    CountdownTimer,
  },

};
</script>

<template lang="pug">
div.countdown-timer.flex.items-center.ph3.pv2(v-show="status !== 'infinite'")
  div.tl.mr5
    h1.stationname.fw6.f5.lh-copy.o-70 {{ station.title }}
    h5.label.fw6.f7.lh-copy(:class="{'-offline': status === 'offline'}") {{ statusLabel }}
  CountdownTimer(v-bind="$props", v-show="status !== 'offline'")
  //- h6.f6.mt3(v-if="status === 'offline'") {{$t('You can keep playing')}}

</template>

<style lang="postcss" scoped>
@keyframes opacityChange {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
.countdown-timer {
  & .label.-offline {
    /* color: red; */
    margin-top: 0;
    animation-name: opacityChange;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
}
</style>
